import { render } from "./edit.vue?vue&type=template&id=7ee4745b&ts=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__